import App from './App.vue';
import router from '@/router';
import { createPinia } from 'pinia';
// import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'; // pinia持久化
import 'amfe-flexible';
import 'vant/lib/index.css';
import '@/styles/index.less';
import '@/assets/font/font.css';

// const pinia = createPinia();
// pinia.use(piniaPluginPersistedstate);

createApp(App).use(router).use(createPinia()).mount('#app');
// createApp(App).use(router).use(pinia).mount('#app');
